
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.5 12.5a1 1 0 01-1 1h-9a1 1 0 01-1-1v-11a1 1 0 011-1h5l5 5v7zM4.5 4.5h2M4.5 7.5h5M4.5 10.5h5","stroke":"#545C69","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    